import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { queryCache, QueryConfig, useQuery } from 'react-query';

import { __DEV__ } from '~src/config';
import { getProjectContactsList } from '~src/services/api';

import { useProjectId } from '../useProjectId';
import { ContactInformationVM } from '~src/types/db';

export const useProjectContacts = (
  tenderId: string | undefined,
  queryConfig: QueryConfig<ContactInformationVM[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();

  useEffect(() => {
    queryCache.invalidateQueries('projectContacts');
  }, [tenderId, projectId]);

  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderDetails = useQuery<ContactInformationVM[], AxiosError>(
    ['projectContacts', { projectId, tenderId }],
    getProjectContactsList,
    {
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenderDetails.data;
};
